export const imagePrompt = (prompt: Function, editor: any, focusEditor: Function) => {
  return prompt('', 'Enter image URL', {
    confirmButtonText: 'Insert',
    cancelButtonText: 'Cancel',
    inputPattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
    inputErrorMessage: 'Invalid URL',
  })
    .then(({ value }: { value: any }) => {
      // this.editor.commands.insertImage(value);
      editor
        .chain()
        .focus()
        .setImage({ src: value })
        .run();
    })
    .catch(() => {
      console.log('Cancelled!');
    })
    .finally(() => {
      focusEditor();
    });
};

export const htmlPrompt = (prompt: Function, editor: any, focusEditor: Function) => {
  return prompt('', 'Enter custom HTML', {
    confirmButtonText: 'Insert',
    cancelButtonText: 'Cancel',
    // inputPattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
    inputErrorMessage: 'Invalid HTML',
  })
    .then(({ value }: { value: any }) => {
      editor.commands.insertHTML(value);
    })
    .catch(() => {
      console.log('Cancelled!');
    })
    .finally(() => {
      focusEditor();
    });
};

export const videoPrompt = (prompt: Function, editor: any, focusEditor: Function) => {
  return prompt('', 'Drop in your YouTube link...', {
    confirmButtonText: 'Insert',
    cancelButtonText: 'Cancel',
    inputPattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
    inputErrorMessage: 'Sorry, that is not a valid link.',
  })
    .then(({ value }: { value: any }) => {
      editor.commands.setYoutubeVideo({
        src: value,
        width: '100%',
        // height: 480,
      });
    })
    .catch(() => {
      console.log('Cancelled!');
    })
    .finally(() => {
      focusEditor();
    });
};

export const linkPrompt = (prompt: Function, editor: any, focusEditor: Function) => {
  return prompt('', 'Enter custom URL', {
    confirmButtonText: 'Insert',
    cancelButtonText: 'Cancel',
    inputPattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
    inputErrorMessage: 'Invalid URL',
  })
    .then(({ value }: { value: any }) => {
      editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: value })
        .run();
    })
    .catch(() => {
      console.log('Cancelled!');
    })
    .finally(() => {
      focusEditor();
    });
};
